module.exports = __webpack_public_path__ + "img/刷卡读卡器 (3).a1e7a396.jpg";